export default __webpack_public_path__ + "static/media/breathing-icon.311e9126.svg";